import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import StyledWrapper from '../../IndividualApplication/style';
import TabPanel from '../../../components/TabPanel/TabPanel';
import a11yProps from '../../../components/TabPanel/A11yProps';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import useGetIndividualAppTable from '../../../hooks/useGetIndividualAppTable';
import AppStagesTable from '../../IndividualApplication/components/AppStagesTable/AppStagesTable';
import ReviewDetails from './ReviewDetails';
import CompareReviews from './CompareReviews';

const ReviewFormContainer = ({ appId, handleAlert }) => {
	const navigate = useNavigate();
	const [value, setValue] = useState(0);
	const [chosenView, setChosenView] = useState(<></>);
	const tabs = ['DETAILS & STATUSES', 'MASTER LAYOUT', 'COMPARE REVIEWS'];

	const pathArray = location?.pathname?.split('/');

	let subPage = pathArray?.filter((e) => e?.includes('rfm-'))?.[0];
	const { data, isLoading, reFormat } = useGetIndividualAppTable({ appId, subPage });
	const title = data[0]?.title;
	const handleChange = (page) => {
		pathArray.pop();
		if (page === 2) {
			pathArray.push('compare-reviews');
		} else if (page === 1) {
			pathArray.push('layout');
		} else {
			pathArray.push('details');
		}
		navigate(pathArray?.join('/'));
	};

	useEffect(() => {
		const actualPage = pathArray[pathArray.length - 1];
		if (actualPage === 'compare-reviews') {
			setValue(2);
			setChosenView(2);
		} else if (actualPage === 'layout') {
			setValue(1);
			setChosenView(1);
		} else {
			setValue(0);
			setChosenView(0);
		}
	}, [pathArray, isLoading]);

	useEffect(() => {
		reFormat();
	}, [location.pathname]);

	return (
		<>
			<StyledWrapper.OutermostContainer style={{ width: '100%', margin: 'auto', gap: '15px' }}>
				<Box sx={{ width: '100%' }}>
					<Box
						data-testid={`individualReview-box`}
						sx={{ padding: '0px 24px', marginBottom: '30px' }}
					>
						<Tabs
							value={value}
							onChange={(e, value) => {
								handleChange(value);
							}}
							aria-label="basic tabs example"
							style={{ width: 'fit-content' }}
						>
							{tabs.map((e, index) => {
								return (
									<Tab
										iconPosition="start"
										data-testid={`individualReview-tab-${index}`}
										key={`FormTab-${index}`}
										label={`${e}`}
										{...a11yProps(e + 1)}
									/>
								);
							})}
						</Tabs>
					</Box>

					<TabPanel data-testid={`individualReview-tab-panel`} value={value} index={value}>
						{chosenView === 0 ? (
							<AppStagesTable data={data} handleAlert={handleAlert} />
						) : chosenView === 1 ? (
							<ReviewDetails isFormsContainer isMasterLayout />
						) : (
							<CompareReviews title={title} />
						)}
					</TabPanel>
				</Box>
			</StyledWrapper.OutermostContainer>
		</>
	);
};

export default ReviewFormContainer;
